uvex-google-map-marker {
  display: none;
}
